const rankings = [
  {
    rank: 1,
    title: '歌手 2024',
    tag: '音乐竞技',
    heat: '本周热度飙升',
    heatIcon: 'ri-fire-fill',
    iconColor: 'text-accent-500',
  },
  {
    rank: 2,
    title: '奔跑吧 第十二季',
    tag: '户外真人秀',
    heat: '连续霸榜 5 周',
    heatIcon: 'ri-trophy-fill',
    iconColor: 'text-primary-500',
  },
  {
    rank: 3,
    title: '脱口秀大会 第六季',
    tag: '脱口秀',
    heat: '口碑持续走高',
    heatIcon: 'ri-thumb-up-fill',
    iconColor: 'text-accent-500',
  },
  {
    rank: 4,
    title: '密室大逃脱 第五季',
    tag: '解谜挑战',
    heat: '新季首播大火',
    heatIcon: 'ri-rocket-fill',
    iconColor: 'text-primary-500',
  },
  {
    rank: 5,
    title: '这！就是街舞 第七季',
    tag: '舞蹈竞技',
    heat: '讨论度暴增',
    heatIcon: 'ri-chat-3-fill',
    iconColor: 'text-accent-500',
  },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            综艺热度榜
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            实时更新，最受观众追捧的热门综艺排行
          </p>
        </div>

        <div className="space-y-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-50 rounded-xl p-4 transition-all hover:-translate-y-0.5"
            >
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 font-black text-base ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                      ? 'bg-primary-400 text-background-50'
                      : item.rank === 3
                        ? 'bg-primary-300 text-background-50'
                        : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-bold text-foreground-950 font-heading truncate">
                  {item.title}
                </h3>
                <span className="inline-block mt-1 px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-[11px] font-medium">
                  {item.tag}
                </span>
              </div>

              <div className="flex items-center gap-1.5 flex-shrink-0">
                <i className={`${item.heatIcon} ${item.iconColor} text-sm`}></i>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}